// Session attribution for the homepage measurement plan.
//
// Every homepage-funnel event (CTA clicks, review-request submission, Health Score
// completion) carries the same four fields so outcomes can be split by source and device:
//   traffic_source  utm_source, else external referrer host, else "direct"
//   device_type     mobile (<768px) | tablet (<1024px) | desktop
//   home_variant    label of the homepage version the visitor saw (bump when copy changes)
//   landing_path    first page of the session, so non-homepage entrants can be filtered out
//
// Conversion definitions (see events fired in ValidationIntake.jsx and HealthScore.jsx):
//   PRIMARY   compliance_review_submitted  - intake form submitted AND the backend returned successfully
//   SECONDARY health_score_completed       - Health Score scored AND the backend returned successfully
// Clicks (home_hero_cta_click, home_final_cta_click) are engagement only, never conversions.
// A *qualified* booking needs a human judgement after follow-up and is not observable here.

import { getVariant } from "@/lib/homeExperiment";

const KEY = "lc_attr_v1";
export const HOME_VARIANT = "focused_v1";

const deviceType = () => {
  if (window.matchMedia("(max-width: 767px)").matches) return "mobile";
  if (window.matchMedia("(max-width: 1023px)").matches) return "tablet";
  return "desktop";
};

const trafficSource = () => {
  const utm = new URLSearchParams(window.location.search).get("utm_source");
  if (utm) return utm.toLowerCase();
  if (document.referrer) {
    try {
      const host = new URL(document.referrer).hostname.replace(/^www\./, "");
      if (host && host !== window.location.hostname.replace(/^www\./, "")) return host;
    } catch {
      // malformed referrer -> treat as direct
    }
  }
  return "direct";
};

export function captureAttribution() {
  if (sessionStorage.getItem(KEY)) return;
  sessionStorage.setItem(
    KEY,
    JSON.stringify({
      traffic_source: trafficSource(),
      device_type: deviceType(),
      home_variant: HOME_VARIANT,
      landing_path: window.location.pathname,
    })
  );
}

// home_variant is the live experiment assignment ("unassigned" if the visitor never saw
// the homepage), so events always agree with the headline the visitor actually saw.
export function getAttribution() {
  captureAttribution();
  let stored = {};
  try {
    stored = JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch {
    // corrupted session value -> fall back to empty attribution rather than crash the caller
  }
  return { ...stored, home_variant: getVariant() || "unassigned" };
}